/**
 * Planning-chat standard: assistant bubbles show prose only — never raw JSON patches.
 * Used by ConversationMessageList (workspace layout) and planning import path.
 */

const AUTHORING_START = '---AUTHORING_JSON---';
const AUTHORING_END = '---END_AUTHORING_JSON---';
const PACK_START = '---PACK_JSON---';
const PACK_END = '---END_PACK_JSON---';

/** Remove fenced ```json blocks and trailing raw JSON objects/arrays. */
export function stripJsonFencesAndTrailing(text: string): string {
  if (!text || typeof text !== 'string') return '';
  let out = text
    .replace(/\s*```(?:json)?\s*[\s\S]*?```\s*/g, '')
    .replace(/\s*```\s*[\s\S]*?```\s*/g, '')
    .trim();
  const trailingMatch = out.match(/\n\s*(\{[\s\S]*\}|\[[\s\S]*\])\s*$/);
  if (trailingMatch) {
    const candidate = trailingMatch[1].trim();
    if (
      (candidate.startsWith('{') && candidate.endsWith('}')) ||
      (candidate.startsWith('[') && candidate.endsWith(']'))
    ) {
      try {
        JSON.parse(candidate);
        out = out.slice(0, trailingMatch.index).trim();
      } catch {
        /* not valid JSON */
      }
    }
  }
  return out;
}

function stripMarkedBlock(text: string, startMarker: string, endMarker: string): string {
  let out = text;
  for (;;) {
    const start = out.indexOf(startMarker);
    if (start < 0) break;
    const end = out.indexOf(endMarker, start + startMarker.length);
    if (end > start) {
      out = `${out.slice(0, start).trim()}\n${out.slice(end + endMarker.length).trim()}`.trim();
    } else {
      out = out.slice(0, start).trim();
      break;
    }
  }
  return out;
}

/** Strip Factory authoring / pack JSON marker blocks from assistant text. */
export function stripStructuredPatchMarkers(text: string): string {
  let out = text;
  out = stripMarkedBlock(out, AUTHORING_START, AUTHORING_END);
  out = stripMarkedBlock(out, PACK_START, PACK_END);
  return out.trim();
}

/** Full assistant display sanitizer (planning + authoring conventions). */
export function stripAssistantDisplayContent(text: string): string {
  const stripped = stripJsonFencesAndTrailing(stripStructuredPatchMarkers(text));
  return stripped.trim();
}
